import React, { useState } from "react";

import globee from "assets/img/globee.png";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer2 from "components/Footers/Footer2";
import bgg from "assets/img/bgg.png";
import bfly1 from "assets/img/bfly1.webp";
import clouds from "assets/img/clouds.webp";
import mail from "assets/img/new/mail.webp";
import contact from "assets/img/new/contact.webp";
import girlll from "assets/img/girlll.png";
import admission from "assets/img/admissions.png";
import hours from "assets/img/hours.png";
import questions from "assets/img/questions.png";
import instagram2 from "assets/img/instagram2.png";
import linkedin1 from "assets/img/linkedin1.png";
import handshake from "assets/img/handshake.png";

export default function ThankyouAdmission() {
  return (
    <>
      <AdminNavbar />
      <section className=" flex relative sticky top-0  parkinsans xl:block lg:block md:block sm:hidden hidden ">
        <div
          className="xl:h-screen lg:h-screen md:h-620
        "
          style={{
            backgroundColor: "#f0f7fa",
            backgroundImage: `url(${bgg})`,
            backgroundPosition: "center center",
            backgroundRepeat: "repeat",
            backgroundSize: "35% auto",
          }}
        >
          <div className=" container mx-auto gap-6 xl:px-0 px-4">
            <div className=" flex justify-start top-0 absolute right-0 ">
              <img
                className="xl:w-44 lg:w-40 md:w-32 w-20 xl:pt-0 lg:pt-0 md:pt-8"
                src={clouds}
                alt=""
              />
            </div>
          </div>
          <div className="grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-2 gap-4  container mx-auto xl:px-0 px-4 xl:pt-32 lg:pt-32 md:pt-32">
            <div className=" xl:col-span-5 lg:col-span-5 md:col-span-5 ">
              <h1 className="xl:text-5xl lg:text-4xl md:text-3xl text-black font-bold xl:w-10/12">
                Thank You for Your Interest in Partnering with Us! 🤝
              </h1>
              <div className="border-peach xl:w-2/12 xl:mt-4 lg:w-3/12 w-24 lg:mt-6 md:mt-6 mt-4"></div>
              <h2 class="xl:text-xl lg:text-xl md:text-xl text-xl font-bold text-black  xl:pt-6 pt-6">
                Dear <span className="text-peach"> Partner,</span>
              </h2>
              <p className="xl:text-lg text-black lg:text-lg text-base xl:pt-4 pt-4 xl:w-8/12">
                We appreciate your interest in collaborating with{" "}
                <span className="font-bold">Junior Toes!</span> Your inquiry has
                been received, and our team will get in touch with you soon to
                discuss the next steps.
              </p>
              <h1 className="xl:text-4xl lg:text-2xl md:text-3xl text-2xl font-bold text-blue xl:pt-4 lg:pt-4 md:mt-4 mt-4">
                For any immediate queries, feel free to:
              </h1>
              <div className="grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2 xl:w-11/12  gap-4">
                <div className="flex items-center gap-4  xl:mt-10 lg:mt-8 md:mt-8 mt-6">
                  <div className="">
                    <img src={mail} alt="" className="w-8" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg  font-semibold">
                        Mail
                      </h5>
                      <p className="text-base">info@juniortoes.com</p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4 items-center  xl:mt-10 lg:mt-4 md:mt-4  ">
                  <div className="">
                    <img src={contact} alt="" className="w-8" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg font-semibold">
                        Contact
                      </h5>
                      <p className="text-base">+91-9035039983</p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4 items-center  xl:mt-10 lg:mt-4 md:mt-4  xl:ml-0 lg:-ml-12 md:-ml-2">
                  <div className="">
                    <img src={globee} alt="" className="w-8" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg font-semibold">
                        Website
                      </h5>
                      <a
                        href="https://www.linkedin.com/company/juniortoes/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p>JuniorToes.com</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className=" absolute left-0 xl:block lg:block md:hidden">
                  <img
                    className="xl:w-32 w-32 xl:-mt-16 lg:mt-8"
                    src={bfly1}
                    alt=""
                  />
                </div>
              </div>
            </div>

            <div className=" xl:col-span-3 lg:col-span-3 md:col-span-3 ">
            <div className="absolute ">
                <img
                  className="xl:w-10/12 lg:w-12/12 xl:mt-0 lg:mt-44 mt-48"
                  src={girlll}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* mobile view */}
      <section className="xl:hidden lg:hidden md:hidden sm:block block ">
        <div
          className="px-4 "
          style={{
            backgroundColor: "#f0f7fa",
            backgroundImage: `url(${bgg})`,
            backgroundPosition: "center center",
            backgroundRepeat: "repeat",
            backgroundSize: "55% auto",
          }}
        >
          <div>
            <div>
              <div className="flex justify-between pt-16">
                <div>
                  <div>
                    <img className="w-32 " src={bfly1} alt="" />
                  </div>
                </div>
                <div>
                  <div className=" absolute right-0">
                    <img className="w-32" src={clouds} alt="" />
                  </div>
                </div>
              </div>
              
            </div>

            <div className="  ">
              <h1 className="text-2xl text-black font-bold pt-8">
                Thank You for Your Interest in Partnering with Us! 🤝
              </h1>
              <div className="border-peach  w-24  mt-4"></div>
              <h2 class=" text-xl font-bold text-black  pt-6">
                Dear <span className="text-peach"> Partner,</span>
              </h2>
              <p className=" text-base  pt-4 ">
                We appreciate your interest in collaborating with{" "}
                <span className="font-bold">Junior Toes!</span> Your inquiry has
                been received, and our team will get in touch with you soon to
                discuss the next steps.
              </p>
              <h1 className=" text-2xl font-bold text-blue  mt-4">
                For any immediate queries, feel free to :
              </h1>
              <div className="  gap-4">
                <div className="flex  gap-4 mt-6">
                  <div className="">
                    <img src={mail} alt="" className="w-8" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue text-lg font-semibold">Mail</h5>
                      <p className="text-base">info@juniortoes.com</p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4  mt-4  ">
                  <div className="">
                    <img src={contact} alt="" className="w-8" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue text-lg font-semibold">
                        Contact
                      </h5>
                      <p className="text-base">+91-9035039983</p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4  mt-4 ">
                  <div className="">
                    <img src={globee} alt="" className="w-8" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg font-semibold">
                        Website
                      </h5>
                      <a
                        href="https://www.linkedin.com/company/juniortoes/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p>JuniorToes.com</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div>
                <img className="w-12/12 pt-6" src={girlll} alt="" />
              </div>
          </div>
        </div>
      </section>

      <section className="xl:mt-16 lg:mt-16 md:mt-16  mt-12 container mx-auto xl:px-0 px-4 xl:block lg:block md:block sm:hidden hidden">
        <h2 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black text-center mb-8">
          What Happens Next?
        </h2>
        <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 gap-8 xl:gap-16 xl:px-32  lg:px-8">
          {/* First Box */}
          <div className="relative">
            <div
              className="flex flex-col items-center border-r-2 border-gray-300 pr-8 h-full mr-8 "
              style={{ borderRight: "1px solid #e4e4e7" }}
            >
              <div
                className="circle1 p-4 border-2 border-blue-500 flex items-center justify-center "
                style={{ border: "3px solid #2d86a4" }}
              >
                <img className="w-24" src={handshake} alt="Admission" />
              </div>
              <p className="xl:text-lg pt-4 text-black text-center font-semibold">
                Our partnership team will review your details.
              </p>
            </div>
          </div>

          {/* Second Box */}
          <div className="relative">
            <div
              className="flex flex-col items-center h-full "
              style={{ borderRight: "1px solid #e4e4e7" }}
            >
              <div
                className="circle1 p-4 border-2 border-blue-500 flex items-center justify-center xl:-ml-8 "
                style={{ border: "3px solid #2d86a4" }}
              >
                <img className="w-24" src={hours} alt="Hours" />
              </div>
              <p className="xl:text-lg pt-4 text-black text-center mr-8 font-semibold">
                Expect a call or email from us within 24-48 hours.
              </p>
            </div>
          </div>

          {/* Third Box */}
          <div className="relative">
            <div className="flex flex-col items-center border-l-2 border-gray-300 pl-8 h-full">
              <div
                className="circle1 p-4 border-2 border-blue-500 flex items-center justify-center"
                style={{ border: "3px solid #2d86a4" }}
              >
                <img className="w-24" src={questions} alt="Questions" />
              </div>
              <p className="xl:text-lg pt-4 text-black text-center font-semibold">
                We’ll guide you through the process and answer any questions.
              </p>
            </div>
          </div>
        </div>
        <h1 className="xl:text-2xl lg:text-2xl text-xl lg:pt-12 pt-12 text-center font-semibold text-black xl:pt-12">
          We look forward to a successful partnership with you! 🚀
        </h1>
      </section>

      {/* mobile view */}
      <section className="px-4 mt-12 container mx-auto  xl:hidden lg:hidden md:hidden sm:block block">
        <h2 className="text-2xl font-bold text-black text-center mb-8">
          What Happens Next?
        </h2>
        <div className="grid grid-cols-1  gap-8">
          {/* First Box */}
          <div className="relative">
            <div className="flex flex-col items-center border-r-2 border-gray-300 pr-8 h-full  ">
              <div
                className="circle1 p-4 border-2 border-blue-500 flex items-center justify-center "
                style={{ border: "3px solid #2d86a4" }}
              >
                <img className="w-24" src={admission} alt="Admission" />
              </div>
              <p className="xl:text-lg pt-4 text-black text-center font-semibold">
                Our partnership team will review your details.
              </p>
            </div>
          </div>

          {/* Second Box */}
          <div className="relative">
            <div className="flex flex-col items-center h-full ">
              <div
                className="circle1 p-4 border-2 border-blue-500 flex items-center justify-center  "
                style={{ border: "3px solid #2d86a4" }}
              >
                <img className="w-24" src={hours} alt="Hours" />
              </div>
              <p className="xl:text-lg pt-4 text-black text-center mr-8 font-semibold">
                Expect a call or email from us within 24-48 hours.
              </p>
            </div>
          </div>

          {/* Third Box */}
          <div className="relative">
            <div className="flex flex-col items-center border-l-2 border-gray-300  h-full">
              <div
                className="circle1 p-4 border-2 border-blue-500 flex items-center justify-center"
                style={{ border: "3px solid #2d86a4" }}
              >
                <img className="w-24" src={questions} alt="Questions" />
              </div>
              <p className="xl:text-lg pt-4 text-black text-center font-semibold">
                We’ll guide you through the process and answer any questions.
              </p>
            </div>
          </div>
        </div>
        <h1 className=" text-xl  pt-12 text-center font-semibold text-black ">
          We look forward to a successful partnership with you! 🚀
        </h1>
      </section>

      <section className="container mx-auto xl:mt-16 xl:pb-16 pb-16 lg:mt-16 md:mt-16 mt-16">
        <h1 className=" xl:text-4xl lg:text-4xl md:text-3xl text-2xl pt-2 font-bold text-blue text-center">
          Stay Connected
        </h1>
        <div className="flex justify-center items-center xl:mt-4 mt-4 gap-3">
          <div>
            <div>
              <a
                href="https://www.instagram.com/juniortoes?igsh=MXNxMTJmMG00bDV5eg=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="w-8" src={instagram2} alt="" />
              </a>
            </div>
          </div>

          <div>
            <div>
              <a
                href="https://www.linkedin.com/company/juniortoes/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="w-8" src={linkedin1} alt="" />
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </>
  );
}
